/* DOZREY – Záloha za ALU obaly (v8: fix prvého kliku, no-cache, dvojitý sync) */
(function () {
  // --- KONFIG ---
  const DEPOSIT_HANDLE = 'zaloha-za-alu-obaly'; // handle produktu zálohy
  const CAN_TAG = 'alu-can';                    // tag na produktoch s plechovkami
  const MULTIPLIER_RE = /^cans-(\d+)$/i;        // napr. "cans-6" → násobič 6

  // Timings (môžeš jemne doladiť podľa témy)
  const FAST_AFTER_NET_MS = 100;  // hneď po sieťovej odpovedi /cart/*
  const FOLLOW_UP_MS      = 500;  // poistka o chvíľu neskôr
  const DEBOUNCE_MS       = 220;  // všeobecné debounce plánovania
  const STABLE_WAIT_MS    = 600;  // max. čas na “ustálenie” košíka
  const STABLE_STEP_MS    = 60;   // interval medzi čítaniami /cart.js

  // --- STAV ---
  let depositVariantId = null;
  let syncing = false;
  let checkingOut = false;
  let __depositSyncTimer = null;

  const log = (...a) => console.info('[DEPOSIT]', ...a);
  const CAN_TAG_LC = CAN_TAG.toLowerCase();

  // --- POMOCNÉ ---
  function handleFromLineItem(li){
    if (li && li.handle) return li.handle;
    if (li && li.url) {
      const m = li.url.match(/\/products\/([^/?#]+)/i);
      if (m) return m[1];
    }
    return null;
  }

  async function fetchJSON(url, init) {
    const res = await fetch(url, Object.assign({ credentials: 'same-origin' }, init));
    if (!res.ok) throw new Error(`HTTP ${res.status} for ${url}`);
    return res.json();
  }

  // no-cache čítanie košíka (odstráni problém “prvého kliku”)
  async function getCart() {
    const url = '/cart.js?ts=' + Date.now();
    return fetchJSON(url, { cache: 'no-store', headers: { 'Cache-Control': 'no-cache' } });
  }

  async function getProductByHandle(h) { return fetchJSON(`/products/${h}.js`); }

  async function getDepositVariantId() {
    if (depositVariantId) return depositVariantId;
    log('Loading deposit product:', DEPOSIT_HANDLE);
    const product = await fetchJSON(`/products/${DEPOSIT_HANDLE}.js`);
    depositVariantId = product?.variants?.[0]?.id;
    if (!depositVariantId) throw new Error('Deposit variant ID not found.');
    log('Deposit variant id =', depositVariantId);
    window.__DEPOSIT_HANDLE = DEPOSIT_HANDLE;
    window.__DEPOSIT_VARIANT_ID = depositVariantId; // využíva ho lock skript v theme
    return depositVariantId;
  }

  const sleep = (ms) => new Promise(r => setTimeout(r, ms));
  function cartSignature(c){
    try { return (c.items||c.line_items||[]).map(i => `${i.key||i.id||i.variant_id}:${i.quantity}`).join('|'); }
    catch(e){ return String(Math.random()); }
  }
  async function getStableCart(maxWaitMs = STABLE_WAIT_MS, step = STABLE_STEP_MS){
    let lastSig = null, lastCart = null, deadline = Date.now()+maxWaitMs;
    while (Date.now() < deadline){
      const c = await getCart();
      const sig = cartSignature(c);
      if (sig === lastSig) return c; // dve po sebe rovnaké čítania = stabilné
      lastSig = sig; lastCart = c;
      await sleep(step);
    }
    return lastCart || await getCart();
  }

  function normalizeTags(raw){
    if (Array.isArray(raw)) return raw.map(x => String(x).trim().toLowerCase()).filter(Boolean);
    if (raw == null) return [];
    return String(raw).split(',').map(x => x.trim().toLowerCase()).filter(Boolean);
  }
  function getMultiplierFromTags(tagsArr){
    for (const t of tagsArr) {
      const m = t.match(MULTIPLIER_RE);
      if (m) {
        const n = parseInt(m[1], 10);
        if (n > 0) return n;
      }
    }
    return 1;
  }
  function getMultiplierFromText(text){
    if (!text) return 1;
    const s = String(text).toLowerCase();
    const m =
      s.match(/\b(\d+)\s*(?:x|×)\b/) ||
      s.match(/\b(\d+)\s*[-\s]?pack\b/) ||
      s.match(/\bpack\s*(?:of)?\s*(\d+)\b/) ||
      s.match(/\b(\d+)\s*(?:ks|pcs)\b/);
    const n = m && parseInt(m[1], 10);
    return (n && n > 1 && n < 1000) ? n : 1;
  }

  async function countCansInCart(cart) {
    const items = cart.items || cart.line_items || [];
    let total = 0;

    const toCheck = items
      .filter(li => !li.gift_card)
      .filter(li => handleFromLineItem(li) !== DEPOSIT_HANDLE);

    const cache = new Map();

    await Promise.all(toCheck.map(async (li) => {
      try {
        const h = handleFromLineItem(li);
        if (!h) { log('No handle for line item, skipping', li); return; }
        if (!cache.has(h)) cache.set(h, await getProductByHandle(h));
        const p = cache.get(h);

        const tagsArr = normalizeTags(p.tags);
        if (!tagsArr.includes(CAN_TAG_LC)) return;

        let mult = getMultiplierFromTags(tagsArr);
        if (mult === 1) {
          mult = Math.max(
            getMultiplierFromText(p.title),
            getMultiplierFromText(li.title),
            getMultiplierFromText(li.product_title),
            getMultiplierFromText(li.variant_title)
          );
        }

        total += (li.quantity || 0) * (mult || 1);
      } catch (e) {
        log('Inspect fail for item', li, e.message || e);
      }
    }));

    log('Total cans counted =', total);
    return total;
  }

  async function doSync(cart){
    const variantId = await getDepositVariantId();
    const items = cart.items || cart.line_items || [];
    const depositLine = items.find(li =>
      (li.variant_id === variantId) ||
      (li.id === variantId) ||
      (handleFromLineItem(li) === DEPOSIT_HANDLE)
    );

    const desiredQty = await countCansInCart(cart);

    if (desiredQty === 0) {
      if (depositLine) {
        log('Removing deposit (no cans).');
        await fetchJSON('/cart/change.js', {
          method:'POST',
          headers:{'Content-Type':'application/json'},
          body: JSON.stringify({ id: depositLine.key || depositLine.id || variantId, quantity: 0 })
        });
      } else {
        log('No cans, deposit not present – OK.');
      }
      return;
    }

    if (depositLine) {
      if (depositLine.quantity !== desiredQty) {
        log(`Updating deposit qty ${depositLine.quantity} -> ${desiredQty}`);
        await fetchJSON('/cart/change.js', {
          method:'POST',
          headers:{'Content-Type':'application/json'},
          body: JSON.stringify({ id: depositLine.key || depositLine.id || variantId, quantity: desiredQty })
        });
      } else {
        log('Deposit qty already correct =', desiredQty);
      }
    } else {
      log('Adding deposit qty =', desiredQty);
      await fetchJSON('/cart/add.js', {
        method:'POST',
        headers:{'Content-Type':'application/json'},
        body: JSON.stringify({ id: variantId, quantity: desiredQty, properties: { _auto: 'Záloha za ALU obaly' } })
      });
    }
  }

  async function syncDeposit(){
    try { await doSync(await getStableCart()); }
    catch(e){ console.warn('[DEPOSIT] sync failed:', e.message||e); }
    finally { document.dispatchEvent(new CustomEvent('deposit:updated')); }
  }

  function scheduleSync(delayMs = DEBOUNCE_MS){
    clearTimeout(__depositSyncTimer);
    __depositSyncTimer = setTimeout(async () => {
      if (syncing) { scheduleSync(120); return; } // počkaj a skús znova
      syncing = true;
      try { await syncDeposit(); }
      finally { syncing = false; }
    }, delayMs);
  }

  function triggerNetSync() {
    // rýchlo po odpovedi + poistka neskôr (sekčné preloady tém apod.)
    scheduleSync(FAST_AFTER_NET_MS);
    scheduleSync(FOLLOW_UP_MS);
  }

  // --- Checkout guard: najskôr sync, potom /checkout
  async function ensureSyncedThenCheckout() {
    if (checkingOut) return;
    checkingOut = true;
    try {
      await syncDeposit();

      // double-check po synce
      const [variantId, cart] = await Promise.all([getDepositVariantId(), getCart()]);
      const desiredQty = await countCansInCart(cart);
      const items = cart.items || cart.line_items || [];
      const depositLine = items.find(li =>
        (li.variant_id === variantId) ||
        (li.id === variantId) ||
        (handleFromLineItem(li) === DEPOSIT_HANDLE)
      );

      if (desiredQty > 0) {
        if (!depositLine || depositLine.quantity !== desiredQty) {
          log('Retry aligning deposit before checkout…');
          if (!depositLine) {
            await fetchJSON('/cart/add.js', {
              method: 'POST',
              headers: {'Content-Type': 'application/json'},
              body: JSON.stringify({ id: variantId, quantity: desiredQty, properties: { _auto: 'Záloha za ALU obaly' } })
            });
          } else {
            await fetchJSON('/cart/change.js', {
              method: 'POST',
              headers: {'Content-Type': 'application/json'},
              body: JSON.stringify({ id: depositLine.key || depositLine.id || variantId, quantity: desiredQty })
            });
          }
          document.dispatchEvent(new CustomEvent('deposit:updated'));
        }
      }
    } catch (e) {
      console.warn('[DEPOSIT] ensure-before-checkout failed:', e.message || e);
    } finally {
      window.location.assign('/checkout');
    }
  }

  // Presná identifikácia checkout akcie
  function isCheckoutTriggerFromClick(target){
    if (!target) return false;
    if (target.closest?.('[data-no-deposit-check]')) return false;
    if (target.closest?.('button[name="checkout"], [name="checkout"], [data-checkout], .cart__checkout, .cart__checkout-button')) return true;
    const a = target.closest?.('a[href]');
    if (a && /\/checkout\b/i.test(a.getAttribute('href') || '')) return true;
    return false;
  }
  function isCheckoutFormSubmit(e){
    const f = e.target;
    if (!f) return false;
    const s = e.submitter || (document.activeElement && document.activeElement.form === f ? document.activeElement : null);
    if (!s) return false;
    return isCheckoutTriggerFromClick(s);
  }

  // --- Hooky na zmeny košíka / udalosti témy ---
  function hookCartMutations() {
    const patt = /\/cart(?:\.|\/)?(add|update|change)(?:\.js)?/i;

    // fetch
    const origFetch = window.fetch;
    window.fetch = async function () {
      const res = await origFetch.apply(this, arguments);
      try {
        const url = (arguments[0] && arguments[0].toString()) || '';
        if (patt.test(url)) triggerNetSync();
      } catch (e) {}
      return res;
    };

    // XHR
    const origOpen = XMLHttpRequest.prototype.open;
    XMLHttpRequest.prototype.open = function (method, url) {
      this.addEventListener('load', function () {
        try {
          const u = (typeof url === 'string') ? url : String(url);
          if (patt.test(u)) triggerNetSync();
        } catch (e) {}
      });
      return origOpen.apply(this, arguments);
    };

    // submit formulárov
    document.addEventListener('submit', function(e){
      const f = e.target;
      if (f && f.action && /\/cart\/add(?:\.js)?/i.test(f.action)) {
        triggerNetSync();
      }
      if (isCheckoutFormSubmit(e)) {
        e.preventDefault(); e.stopPropagation();
        ensureSyncedThenCheckout();
      }
    }, true);

    // kliky
    document.addEventListener('click', function(e){
      if (isCheckoutTriggerFromClick(e.target)) {
        e.preventDefault(); e.stopImmediatePropagation();
        ensureSyncedThenCheckout();
        return;
      }
      const addBtn = e.target.closest && e.target.closest('button[type="submit"][name="add"], [data-add-to-cart], .product-form__submit');
      if (addBtn) triggerNetSync();
    }, true);

    // staršie globálne callbacky Shopify
    if (window.Shopify) {
      const origOnItemAdded = window.Shopify.onItemAdded;
      window.Shopify.onItemAdded = function(){
        try { triggerNetSync(); } catch(e){}
        if (typeof origOnItemAdded === 'function') return origOnItemAdded.apply(this, arguments);
      };
    }

    // custom eventy tém/apiek
    ['cart:change','cart:updated','cart:refresh','ajaxProduct:added','product:added','drawer:open','cart-drawer:open','sections:load']
      .forEach(evt => document.addEventListener(evt, () => { triggerNetSync(); }));

    // zmena DOM (drawer, sekcie…)
    const mo = new MutationObserver(() => { triggerNetSync(); });
    mo.observe(document.body, { childList:true, subtree:true });
  }

  // ručný beh pre konzolu (window.depositSync())
  window.depositSync = syncDeposit;

  // štart
  console.info('[DEPOSIT] v8 loaded');
  document.addEventListener('DOMContentLoaded', function () {
    hookCartMutations();
    scheduleSync(DEBOUNCE_MS);
    scheduleSync(FOLLOW_UP_MS); // poistka po loade
  });
})();